import { Component } from '@angular/core';
import { Modal } from 'bootstrap';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})


export class FooterComponent {

  langDictionary:any;
  footerDisclaimer!:string;
  private _date:Date = new Date()

  constructor(private globalService: GlobalService){

  }
  get getDate(){
    return this._date.getFullYear();
  }
  ngOnInit():void{
    this.globalService.jobInformation.subscribe(data=>{
      this.footerDisclaimer = data.pageData?.disclaimers?.footerDisclaimer;
    })
    this.langDictionary = this.globalService.Language;
  }
  
openModal(type:string) {
  if(type == 'privacy'){
    const modalElement = document.getElementById('privacymodal');
    const modal =  new Modal(modalElement!);
    modal.show();
  }else if(type == 'tandc'){
    const modalElement = document.getElementById('tancmodal');
    const modal =  new Modal(modalElement!);
    modal.show();
  }
  
}
openAnchorModal(event:Event){
  event.preventDefault();
  this.openModal('privacy')
}
}
